"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VatValidationErrorToJSON = exports.VatValidationErrorFromJSONTyped = exports.VatValidationErrorFromJSON = exports.instanceOfVatValidationError = exports.VatValidationErrorErrorTypeEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.VatValidationErrorErrorTypeEnum = {
    Unknown: 'UNKNOWN',
    Timeout: 'TIMEOUT',
    InvalidId: 'INVALID_ID',
    ExVatServiceUnavailable: 'EX_VAT_SERVICE_UNAVAILABLE'
};
/**
 * Check if a given object implements the VatValidationError interface.
 */
function instanceOfVatValidationError(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfVatValidationError = instanceOfVatValidationError;
function VatValidationErrorFromJSON(json) {
    return VatValidationErrorFromJSONTyped(json, false);
}
exports.VatValidationErrorFromJSON = VatValidationErrorFromJSON;
function VatValidationErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'errorType': !(0, runtime_1.exists)(json, 'error_type') ? undefined : json['error_type'],
        'message': !(0, runtime_1.exists)(json, 'message') ? undefined : json['message'],
    };
}
exports.VatValidationErrorFromJSONTyped = VatValidationErrorFromJSONTyped;
function VatValidationErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'error_type': value.errorType,
        'message': value.message,
    };
}
exports.VatValidationErrorToJSON = VatValidationErrorToJSON;
